// All URL's must be HTTPS. No Exceptions!
export const environment = {
  production: true,
  loginUrl: 'https://orders.clsl.co.uk/ordering/login',
  resetUrl: 'https://orders.clsl.co.uk/ordering/login/resetpassword',
  orderingUrl: 'https://orders.clsl.co.uk/ordering/newcase',
  registerUrl: 'https://ordering.futureclimateinfo.com/ordering/register',
  thirdPartyTermsUrl: 'https://orders.clsl.co.uk/ordering/thirdpartyterms',
  analytics: '2e1910a1-ace9-42e3-99ef-93a76c486a78',
  frontend: 'https://orders.clsl.co.uk/',
  ordering: 'https://orders.clsl.co.uk/',
  providerInheritanceData: 'https://secure.clsl.co.uk:5151/Provider/Edit/1015',
  insightsKey: '9931b250-968e-4a75-8c5a-07abaf646046',
  layername: 'orderingpreprod',
  googleAnlaytics: 'UA-20220060-1',
  userbackAccessToken: '10424|20982|1aSDyzjM8EA5P6bW8TIKPjOcl',
  productsToBypassFcaCheck: [250, 501, 509],
  FCIRegisterURL: 'https://ordering.futureclimateinfo.com/ordering/register',
  restApiUrl: 'https://cls-restapi.azurewebsites.net',
  hideGuardianshipBondDate: '2023-12-31 23:59:59',
  jkwDefaultLoi: 20000,
  notificationApiUrl: 'https://cls-motd.azurewebsites.net/Message/pipa'
};


